import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const initialState = {
  open: false,
  message: '',
  severity: '',
  action: false,
  autoHideDuration: 5000,
}

const snackbarSlice = createSlice({
  name: 'snackbarSlice',
  initialState,
  reducers: {
    setSnackbar(state, action) {
      state.open = true
      state.message = action.payload.message
      state.severity = action.payload.severity
      state.autoHideDuration = action.payload.autoHideDuration
      state.action = action.payload.action
    },
    resetSnackbar(state) {
      state.open = false
      state.message = ''
      state.severity = ''
      state.autoHideDuration = 5000
      state.action = false
    },
  },
  extraReducers: (builder) => {
    /* Action which gets triggered
       when running persistor.purge() */
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
})

export const { setSnackbar, resetSnackbar } = snackbarSlice.actions

export default snackbarSlice.reducer
